// extracted by mini-css-extract-plugin
export default {"main_cart":"CartCard_main_cart__PFIYZ","card_action":"CartCard_card_action__aR6QK","img_box":"CartCard_img_box__CkeH0","img":"CartCard_img__rTjfC"};